import { render, staticRenderFns } from "./luolaCfg.vue?vue&type=template&id=60314238&scoped=true"
import script from "./luolaCfg.vue?vue&type=script&lang=js"
export * from "./luolaCfg.vue?vue&type=script&lang=js"
import style0 from "./luolaCfg.vue?vue&type=style&index=0&id=60314238&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60314238",
  null
  
)

export default component.exports